import { logError, post } from 'utils';

/**
 * @typedef {Object} ApiParams
 * @property {string} file Base64 encoded file data
 * @property {string} tags tags to apply to the file
 * @property {import('utils/types').UploadCategory} category the category of the file being uploaded
 */

/**
 * @param {ApiParams} params
 * @param {Function} onProgress
 * @param {Function} onSuccess
 * @param {Function} onError
 * @param {Function} onFinally
 */

export function uploadFile(
  params,
  onProgress = () => {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  post(
    { apiKey: 'fileUpload' },
    { params, config: { onUploadProgress: onProgress, timeout: 60000 } }
  )
    .then(({ data }) => onSuccess(data))
    .catch(err => {
      logError(err, { customMessage: 'Failed to upload file' });
      onError(err);
    })
    .finally(onFinally);
}
